import { SearchContext } from 'components/search/SearchContext';
import { SearchResultsPage } from 'components/search/SearchResultsPage';

export const TogoSearchResults = () => {
  return (
    <SearchContext locale="en-US" type="togo">
      <SearchResultsPage />
    </SearchContext>
  );
};
